import classNames from 'classnames';
import React from 'react';
import { useIsFormValid } from 'sharedreact/components/ValidationForm';

type Props = {
  id: string,
  className?: string,
  disabled?: boolean,
  type?: string,
  icon?: string,
  badgeValue?: React.ReactNode,
  children?: React.ReactNode,
  collapsable?: boolean,
  onlyShowIconWhenCollapsed?: boolean,
  active?: boolean,
  autoFocus?: boolean,
  title?: string,
  forceNoIconMarging?: boolean,
  disableOnFormValidationErrors?: boolean,

  onClick?: React.MouseEventHandler<HTMLButtonElement>,
  // onMouseDown should only be used if you have a component that wants to
  // handle AEButon clicks and onBlur and wants different behaviour for those
  // actions
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>,
  onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>
};

function Button ({
  id, className, disabled, type = 'btn-default',
  icon, badgeValue, children, collapsable,
  onlyShowIconWhenCollapsed, active, autoFocus,
  disableOnFormValidationErrors,
  title, forceNoIconMarging, onClick, onMouseDown,
  onMouseEnter
}: Props) {
  const buttonClassName = classNames(
    'esko_btn',
    type.split(' ').map(className => 'esko_' + className).join(' '),
    className, {
      active: active
    }
  );

  const [isFormValid] = useIsFormValid();

  const buttonDisabled = (onClick == null && onMouseDown == null) ||
    disabled ||
    (disableOnFormValidationErrors === true && !isFormValid);

  if (icon != null) {
    if (collapsable) {
      if (onlyShowIconWhenCollapsed) {
        return (
          <button id={id}
            type='button'
            className={buttonClassName}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseEnter={onMouseEnter}
            disabled={buttonDisabled}
            autoFocus={autoFocus}
            title={buttonDisabled ? undefined : title}
          >
            <div className='esko_visible-lg-inline esko_visible-md-inline'>
              {children}
            </div>
            <div className='esko_visible-xs-inline esko_visible-sm-inline'>
              <span className={icon}>
                {badgeValue}
              </span>
            </div>
          </button>
        );
      } else {
        return (
          <button id={id}
            type='button'
            className={buttonClassName}
            onClick={onClick}
            onMouseDown={onMouseDown}
            onMouseEnter={onMouseEnter}
            disabled={buttonDisabled}
            autoFocus={autoFocus}
            title={buttonDisabled ? undefined : title}
          >
            <div className='esko_visible-lg-inline esko_visible-md-inline'>
              <span className={icon} style={React.Children.count(children) > 0 && !forceNoIconMarging ? {marginRight: '5px'} : {}}>{badgeValue}</span>{children}
            </div>
            <div className='esko_visible-xs-inline esko_visible-sm-inline'>
              <span className={icon}>
                {badgeValue}
              </span>
            </div>
          </button>
        );
      }
    } else {
      return (
        <button id={id}
          type='button'
          className={buttonClassName}
          onClick={onClick}
          onMouseDown={onMouseDown}
          onMouseEnter={onMouseEnter}
          disabled={buttonDisabled}
          autoFocus={autoFocus}
          title={buttonDisabled ? undefined : title}
        >
          <span className={icon} style={React.Children.count(children) > 0 && !forceNoIconMarging ? {marginRight: '5px'} : {}}>{badgeValue}</span>{children}
        </button>
      );
    }
  } else {
    return (
      <button id={id}
        type='button'
        className={buttonClassName}
        onClick={onClick}
        onMouseDown={onMouseDown}
        onMouseEnter={onMouseEnter}
        disabled={buttonDisabled}
        autoFocus={autoFocus}
        title={buttonDisabled ? undefined : title}
      >
        {children}
      </button>
    );
  }
}

export default Button;
